import type { MetaItemTranslations } from 'models';
import type { EntityDataObject } from 'models/service';
import type { ApiClientResponse } from './api';
import apiClient from './api-client';
import { routes } from './routes';

export type ChangeRequestData = {
  subject_id: string;
};

type CommunityJoinRequestData = {
  kind: 'community_request_to_join';
  meta: {
    reason_to_join?: string;
  };
  subject_type: 'Community';
} & ChangeRequestData;

type ContactUsRequestData = {
  kind: 'program_request_to_contact';
  meta: {
    invitation_phone: string;
  };
  subject_type: 'Program';
} & ChangeRequestData;

type ProgramJoinRequestData = {
  kind: 'program_request_to_join';
  meta: {
    reason_to_join?: string;
  };
  subject_type: 'Program';
} & ChangeRequestData;

type TelehealthRequestData = {
  kind: 'event_request_to_create';
  meta: {
    html_content: string;
    patient_type: TelehealthTypeRequestData;
    text_content: string;
    visit_date: Date;
    visit_duration: number;
    visit_type: TelehealthTypeRequestData;
    visit_type_option: TelehealthTypeRequestData;
    visit_type_sub_option?: TelehealthTypeRequestData;
  };
  subject_type: 'Community';
} & ChangeRequestData;

type TelehealthTypeRequestData = {
  name: string;
  translations: MetaItemTranslations;
};

export const changeRequest = async (
  data: CommunityJoinRequestData | ContactUsRequestData | ProgramJoinRequestData | TelehealthRequestData,
) => apiClient.post<EntityDataObject, ApiClientResponse<EntityDataObject>>(routes.changeRequests.post, data);
